module.exports = __webpack_public_path__ + "static/img/logo-5-2.badb6dbd.png";